"use client";
import React from "react";
import Head from "next/head";
import PageInformationCard from "~/components/PageInformationCard.jsx";
import { getQualityCheckPageData, getWarehouseIncomingItemsPageData, getWarehouseIntegrationsPageData } from "~/cores/pageAccessCore";
import { useAppProps } from "~/app/_apps/AppPropsContext";
import WarehouseReportsContent from "./WarehouseReportsContent";
import TurnrLink from "~/components/links/TurnrLink";
import ExternalLink from "~/components/ExternalLink.jsx";

export function getWarehouseReportsPageText() {
    return (
        <div>
            A warehouse report is created when items are received by the warehouse. There are 3 ways these can be generated.
            <br />
            <br />
            1. Submitted using Ingrid's Warehouse <TurnrLink href={getQualityCheckPageData().href}>Quality Check</TurnrLink>. You can change how these reports are generated in Admin Shop Settings
            <br />
            2. Received automatically by your WMS using our <TurnrLink href={getWarehouseIntegrationsPageData().href}>Warehouse Integrations</TurnrLink> <br />
            3. Submitted using Ingrid's Merchant API where your warehouse has an integration to our system.{" "}
            <ExternalLink style={{ display: "inline-block" }} href={"https://ingrid.slite.page/p/O2PG1ghYFLisbn/Ingrid-Returns-Developer-Integration-Guide"}>
                Read more
            </ExternalLink>
        </div>
    );
}

export default function WarehouseIncomingItemsPage() {
    const { appProps } = useAppProps();
    return (
        <>
            <Head>
                <title>Warehouse reports</title>
            </Head>
            <PageInformationCard iconProps={{ flip: "horizontal" }} icon={getWarehouseIncomingItemsPageData().icon} title={"Warehouse reports"} content={getWarehouseReportsPageText()} />
            <WarehouseReportsContent appProps={appProps} />
        </>
    );
}
